import React, { forwardRef, useState } from 'react';
import copyToClipboard from 'copy-to-clipboard';
import cn from 'classnames';
import Multiclamp from 'react-multi-clamp';
import { CopyTextProps } from './types';
import STRINGS from './strings';
import { BUTTON } from '../classnames';
import Text from '../../Text';
import TextLink from '../TextLink';

const CopyText = forwardRef<any, CopyTextProps>(
  (
    {
      text,
      copied: copiedProp,
      lang = 'es',
      delay = 1000,
      as,
      onClick: onClickProp,
      className = '',
      ...other
    },
    ref,
  ) => {
    const [copyTimeout, setCopyTimeout] = useState<number | undefined>();
    const [copied, setCopied] = useState<boolean>(false);
    const Tag: keyof JSX.IntrinsicElements = as || 'button';

    const onClick = e => {
      if (copyTimeout) {
        clearTimeout(copyTimeout);
      }
      setCopied(true);
      copyToClipboard(text);

      setCopyTimeout(
        setTimeout(() => {
          setCopied(false);
        }, delay),
      );
      if (onClickProp) {
        onClickProp(e);
      }
    };

    return (
      <Tag
        className={cn(
          BUTTON,
          'justify-between p-8 border border-solid border-gray-main bg-gray-lighter',
          className,
        )}
        onClick={onClick}
        ref={ref}
        {...other}
      >
        <Text
          type="legals"
          className="overflow-hidden"
          style={{ maxHeight: '16px' }}
        >
          {text ? <Multiclamp clamp={1}>{text}</Multiclamp> : ''}
        </Text>
        <TextLink
          as="span"
          className="ml-16"
          label={
            copiedProp || copied ? STRINGS[lang].COPIED : STRINGS[lang].COPY
          }
        />
      </Tag>
    );
  },
);

export default CopyText;
